<template>
  <div :style="{background: menuBgcolor,color: menuFontColor }" class="header_main">
    <div class="header_content" id="header_content">
      <div class="header-left">
        <img class="img" src="../../assets/img/logo.png" alt="纳微创新主标识" />
        <img class="img" src="../../assets/img/logo2.png" alt="纳微创新品牌标识" />
      </div>
      <div class="header_search">
        <search></search>
      </div>
      <el-divider direction="vertical"></el-divider>
      <div class="header_phone">
        <div>
          <img class="phoneImg" src="../../assets/img/phone.png" alt="服务热线图标" />
        </div>
        <div>
          <span>全国统一服务热线</span>
          <div>400-168-0661</div>
        </div>
      </div>
      <el-divider direction="vertical"></el-divider>
      <div class="login_btn">
        <div v-if="!token" class="login" @click="toLogin()">注册/登录</div>
        <el-dropdown class="avatar-container right-menu-item hover-effect" v-if="token && token != ''">
          <div class="avatar-wrapper" >

            <el-image :src="avatar" class="user-avatar">
              <div slot="error">
                <img src="@/assets/img/avatar.png" class="user-avatar" alt="用户头像" />
              </div>
            </el-image>
            <div class="user-name">
              {{name}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item  @click.native="toProfile('1-2','个人资料')">
              <span>个人资料</span>
            </el-dropdown-item>
            <el-dropdown-item  @click.native="toProfile('1-1','我的资产')">
              <span>我的资产</span>
            </el-dropdown-item>
            <el-dropdown-item  @click.native="toProfile('2-1','我的订单')">
              <span>我的订单</span>
            </el-dropdown-item>
            <el-dropdown-item  @click.native="toProfile('4-1','加入团队')">
              <span>我的团队</span>
            </el-dropdown-item>
            <el-dropdown-item  @click.native="toProfile('1-4','邀请好友')">
              <span>邀请好友</span>
            </el-dropdown-item>
            <el-dropdown-item  @click.native="toProfile('3-2','我的发票')">
              <span>我的发票</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="yucun" v-if="token && token != ''" @click="toYc">
          <img src="../../assets/img/yucunyouli.png" alt="预存有礼活动入口">
        </div>
        <el-button class="free" v-if="!token" @click="toLogin">免费发布信息</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { removeToken,removeClient,removeReagentTeamInfo } from "@/plugins/auth";
import { mapGetters } from 'vuex'
import { logout } from "@/api/request"
import search from "./search"
export default {
  components: {
    search
  },
  props: {
    menuBgcolor: {
      default: "",
      type: String
    },
    menuFontColor: {
      default: "",
      type: String
    }
  },
  data() {
    return {
      teamId: null,
      value: ''
    };
  },
  computed: {
    ...mapGetters(['token','avatar','name']),
  },
  watch: {
    "$store.getters.userInfo.teamId": {
      handler: function(newVal, oldVal) {
        if (newVal) {
          this.teamId = newVal
        }
      }
    }
  },
  methods: {
    logout () {
      this.$confirm('确认退出登录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          logout().then(res=> {
            this.$router.push({path: "/",});
            removeToken()
            removeClient()
            removeReagentTeamInfo()
            this.$store.commit("SET_TOKEN", undefined);
            this.$store.commit("SET_LOGINFLAG", 0);
          })
        }).catch(() => {});
      
    },
    toProfile (index,name) {
      if (index == '4-1') {
        if (this.teamId) {
          index = '4-3'
          name = '我的团队'
        }
      }
      this.$router.push({
        path: "/aboutUsIndex",
        query: {type: 13, tabIndex: index,tabName: name }
      });
    },
    // 登录操作统一跳转独立页面，并保留当前页面作为登录后的返回地址。
    toLogin() {
      const query = {
        redirect: this.$route.fullPath,
      }
      if(this.$route.query.inviterPhoneNumber) {
        query.inviterType = this.$route.query.inviterType
        query.inviterPhoneNumber = this.$route.query.inviterPhoneNumber
        query.mode = 'sms'
      }
      this.$router.push({
        path: '/login',
        query,
      })
    },
    toYc(){
      let host = location.host;
      let url = '/aboutUsIndex?type=13&tabIndex=1-1&tabName=%E6%88%91%E7%9A%84%E8%B5%84%E4%BA%A7'
      window.location.href = url
      // window.location.href = 'https://www.navi-sci.cn/aboutUsIndex?type=13&tabIndex=1-1&tabName=%E6%88%91%E7%9A%84%E8%B5%84%E4%BA%A7'
    }
  }
};
</script>
<style scoped lang="scss">
.header_main {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
}
.header_content {
  width: 80%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  padding: 10px;
}
.header-left {
  width: 30%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
}
.header_search {
  width: 35%;
  margin-left: 30px;
  margin-right: 30px;
}
.header_phone {
  width: 250px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  color: #4d6fff;
  font-size: 16px;
  text-align: center;
}
.login {
  width: 100px;
  padding-left: 50px;
  color: #4d6fff;
  cursor: pointer;
}
.img {
  width: 45%;
}
.phoneImg {
  width: 30px;
  height: 30px;
  margin-right: 20px;
}
.avatar-container {
  // margin-right: 20px;
  min-width: 120px;
  .avatar-wrapper {
    display: flex;
    flex-flow: row nowrap;
    justify-content: right;
    margin-top: 5px;
    position: relative;
    height: 40px;
    line-height: 40px;
    .user-avatar {
      cursor: pointer;
      width: 36px;
      height: 36px;
      border-radius: 50%;
    }
    .user-name {
      font-size: 14px;
      margin-left: 10px;
      color: #4d6fff;
      cursor: pointer;
    }
    .el-icon-caret-bottom {
      cursor: pointer;
      font-size: 14px;
      color: #999999;
    }
  }
}
.yucun{
  width: 80px;
  height: 22px;
  margin-left: 10px;
  cursor: pointer;
  img{
    width: 76px;
    height: 22px;
  }
}
.free {
  height: 25px;
  padding: 0 5px;
  border-radius: 5px;
}
.login_btn{
  display: flex;
  align-items: center;
}
</style>
<style>
.header_main .el-divider--vertical {
  width: 2px;
  height: 2em;
}
.header_search .header_main .el-input-group--append .el-input__inner {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  border: 1px solid #4d6fff;
}
.header_search .el-input-group__append, .el-input-group__prepend {
  padding: 0 5px;
}
.header_search .el-input-group__append {
  /* width: 50px; */
  background: #4d6fff;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  border: 1px solid #4d6fff;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
</style>
